import * as actionTypes from '../action-creator/actionTypes';
import { combineReducers } from 'redux';

const appBarTitle = (state = "", action) => {
  switch(action.type){
    case actionTypes.SET_APP_BAR_TITLE:
      return action.title;
    default:
      return state;
  }
}

const appBarLeftElement = (state = null, action) => {
  switch(action.type){
    case actionTypes.SET_APP_BAR_LEFT_ELEMENT:
      return action.node;
    default:
      return state;
  }
}

const appBarRightElement = (state = null, action) => {
  switch(action.type){
    case actionTypes.SET_APP_BAR_RIGHT_ELEMENT:
      return action.node;
    default:
      return state;
  }
}

const appBarCenterElement = (state = null, action) => {
  switch(action.type){
    case actionTypes.SET_APP_BAR_CENTER_ELEMENT:
      return action.node;
    default:
      return state;
  }
}

const appBarVisibility = (state = true, action) => {
  switch(action.type){
    case actionTypes.SET_APP_BAR_VISIBLITY:
      return action.visible;
    default:
      return state;
  }
}

export default combineReducers({
  appBarLeftElement,
  appBarRightElement,
  appBarCenterElement,
  appBarTitle,
  appBarVisibility
});

const getCurrentState = state => state.mainAppBar;
export const getAppBarTitle = state => getCurrentState(state).appBarTitle;
export const getAppBarLeftElement = state => getCurrentState(state).appBarLeftElement;
export const getAppBarRightElement = state => getCurrentState(state).appBarRightElement;
export const getAppBarCenterElement = state => getCurrentState(state).appBarCenterElement;
export const isAppBarVisible = state => getCurrentState(state).appBarVisibility;
